import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import shortid from 'shortid'

import { 
  tryToCreateTeam,
  showTooltip, 
  hideTooltip 
} from '../actions/actions.export.js';

import LoginForm from '../components/LoginForm/LoginForm.js'
import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Checkbox from '../components/Checkbox/Checkbox.js'
import Tags from '../components/Tags/Tags.js'
import Tabs from '../components/Tabs/Tabs.js'
import CustomField from '../components/CustomField/CustomField.js'
import CreateATeamSubscriptionCCForm from '../components/CreateATeamSubscriptionCCForm/CreateATeamSubscriptionCCForm.js'

var pf_config = require('../pf_config.json');

class CreateATeam extends Component {

  constructor(props){
    super(props);

    this.state = {
      lastFail: props.team.failedToCreateTeam,
    }
  }


  componentDidMount(){
    window.document.title = "Create a Firm - Pattycake";
  
    this.setState({
      idempotency_key: shortid.generate()
    })
  }


  render(){
    const state = this.state;
    const { dispatch, team, user, change } = this.props;
    const that = this;

    return <div className="body-stretch">
      <Header transparent={true}/>
      <div className="stretched">
        <div className="container">
          <div className="row justify-content-center row-mega-padded">
            <div className="col-md-4">
              <h1 className="text-center">
                Collaboration is key.
              </h1>
              <p className="lead text-center p-push-down">Start a free trial of Pattycake for Firms.</p>
              <CreateATeamSubscriptionCCForm 
                price={ pf_config.plans.teams.price }
              />
            </div>    
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}


CreateATeam = reduxForm({
  // a unique name for the form
  form: 'CreateATeam',
  enableReinitialize: true,
  destroyOnUnmount: false
})(CreateATeam)

CreateATeam = connect((state, ownProps) => {
  const { user, team } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    team,
    initialValues
  }
})(CreateATeam);


export default CreateATeam;



// WEBPACK FOOTER //
// ./src/routes/Create-A-Team.js